module.exports = __webpack_public_path__ + "img/HD_tc_bg_f59569884.png";